import { useListParams } from "hooks/useListParams"
import { STOCK_SORT_OPTIONS } from "hooks/useVehicleImporter"
import { useEffect, useRef } from "react"
import { Badge } from "reactstrap"

const StockSorting = () => {
  const { params, updateParams } = useListParams()
  const initializedRef = useRef(false)

  // Set default sort once
  useEffect(() => {
    if (!initializedRef.current) {
      if (!params.group_sort) {
        updateParams({ group_sort: STOCK_SORT_OPTIONS.TITLE })
      }
      initializedRef.current = true
    }
  }, [params.group_sort, updateParams])

  const sortOptionsArray = Object.entries(STOCK_SORT_OPTIONS).map(
    ([key, value]) => ({ key, value })
  )

  const handleSortChange = value => {
    updateParams({ group_sort: value })
  }

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <div className="fw-semibold me-2">Sort By:</div>

      {sortOptionsArray.map(option => {
        // default active state to TITLE if group_sort is not set
        const isActive = !params.group_sort ? option.value === STOCK_SORT_OPTIONS.TITLE : params.group_sort === option.value
        return (
          <Badge
            style={{
              cursor: "pointer",
            }}
            color={isActive ? "primary" : "light"}
            key={option.key}
            onClick={() => handleSortChange(option.value)}
          >
            {option.value.replace("_", " ").toUpperCase()}
          </Badge>
        )
      })}
    </div>
  )
}

export default StockSorting
